/*
 * @Author: Michael
 * @Date: 2018-09-18 15:16:19
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-08-19 10:33:21
 */
import { State } from '@/common/interface';
import getUrlParam from '@/common/utils/getUrlParam';

/* eslint-disable */
const fortheenDaysStemp = 24 * 3600 * 1000 * 14;

const state: State = {
  oldPrizeList: [],
  xcxFlag: false,
  isInvalid: false,
  isAgain: false,
  madeByOrg: false,
  openId: process.env.NODE_ENV === 'production' ? '' : 'oUI8C5ZDLdfkjzO-l7bAuu-RYuvYw', //  调试使用
  instId: '',
  leadersInstId: '',
  payInstId: '',
  orgId: '',
  instIds: [],
  instList: [],
  instVOList: [],
  instNameNot: [],
  instNameFew: [],
  instNameZero: [],
  uid: '',
  name: '',
  phone: '',
  htmUrl: '',
  cover: '',
  qrCodeUrl: '',
  signature: {
    appId: '',
    nonceStr: '',
    signature: '',
    timestamp: ''
  },
  originalTitle: '',
  documentTitle: '',
  coverTiny: '',
  coverMiddle: '',
  coverLarge: '',
  topTips: '',
  mainBackgroundColor: '',
  mainTextColor: '',
  gradientColor: 'linear-gradient(90deg,rgba(254,1,64,1) 0%,rgba(255,87,40,1) 100%)',
  bgmList: [],
  customizeBgmList: [],
  solitaireList: [],
  musicTagBgColor: '',
  musicTagTextColor: '',
  section: {
    inputBackgroundColor: '#f8f9fc',
    inputFontColor: '#666',
    titleBackground: 'https://image.xiaomaiketang.com/xm/DFw3AGyrbJ.png',
    titleColor: '#fff',
    borderRadius: 10,
    showBorder: false,
    borderColor: '#000',
    borderWidth: 2,
    backgroundColor: 'rgba(255,255,255,1)',
    textColor: 'transparent',
    speicalTextColor: 'transparent', // 特显文字颜色
    prizeName: '',
    prizePic: '',
    prizeDesc: '',
    prizeNumber: 0,
    prizeIntros: [
      {
        type: 'text',
        value: ''
      }
    ],
    courseDesc:
      '儿童创意绘画是启发少儿思维及智力的有效载体,儿童绘画能力的发展与其心理发展紧密相连。通过系统学习,可以提升少儿的注意力、观察力、想象力、创造力等思维能力、绘画能力、动手操作能力、学习能力及性格能力,同时还可以培养孩子发现美、创造美、体验',
    courseName: '100元小麦艺术培训课',
    coursePic: 'https://image.xiaomaiketang.com/xm/3ErNciKrxw.png',
    courseType: 'ONE', // 团购-课程类型
    courseIntros: [
      {
        type: 'text',
        value:
          '儿童创意绘画是启发少儿思维及智力的有效载体,儿童绘画能力的发展与其心理发展紧密相连。通过系统学习,可以提升少儿的注意力、观察力、想象力、创造力等思维能力、绘画能力、动手操作能力、学习能力及性格能力,同时还可以培养孩子发现美、创造美、体验'
      }
    ],
    courseGroupList: [], // 团购-多课程
    currentPrice: 1,
    groupNumber: 50,
    originPrice: 299,
    personNumber: 20,
    dayTimes: 5,
    totalTimes: 5,
    limitBuyerNum: 100,
    courseOriginPrice: 699,
    courseRushPrice: 99,
    selectedSeqNo:1
  },
  titleSection: {
    borderRadius: 10,
    showBorder: false,
    borderColor: '#000',
    borderWidth: 2,
    backgroundColor: 'rgba(255,255,255,1)',
    titleColor: '#000',
    titleWeight: 500,
    contentColor: '#333',
    numberColor: '#6271f8',
    deadlineBg: '',
    deadlineTextColor: 'transparent',
    deadlineNumberColor: 'transparent',
    processColor: 'transparent',
    prizeNameColor: 'transparent',
    avatarTextColor: 'transparent',
    avatarBgColor: 'transparent',
    avatarBorderColor: 'transparent',
    wozijikan: '',
    woyaokanjia: '',
    bangtakan: '',
    fanhuiwodehuodong: '',
    zhaorenbangkan: '',
    dadao: '',
    zhongdao: '',
    xiaodao: '',
    getPrizesVerb: '', // 集赞动词
    getPrizesUnit: '', // 集赞单位
    getPrizesNoun: '', // 集赞名词
    shareGuidePic: '', // 分享图
    tyBadImg: '', // 10%图片
    tyNormalImg: '', // 65%图片
    tyGoodImg: '', // 25%图片
    tyBadImgName: '', // 10%图片名称
    tyNormalImgName: '', // 65%图片名称
    tyGoodImgName: '', // 25%图片名称
    rushToBuy: '',
    gotoPay: '',
    checkMyRecord: ''
  },
  buttonSection: {
    backgroundColor: 'rgba(255,255,255,1)',
    textColor: '#A34529',
    textWeight: 400,
    subTextColor: '#9B9B9B'
  },
  numberSection: {
    borderRadius: 10,
    showBorder: false,
    borderColor: '#000',
    borderWidth: 2,
    backgroundColor: 'rgba(255,223,0,1)',
    textColor: '#8E5900',
    numberColor: '#FF3964'
  },
  modalSection: {
    backgroundColor: '',
    joinText: ''
  },
  title: '',
  deadline: new Date().setHours(23, 0, 0).valueOf() + fortheenDaysStemp,
  startTime: new Date().valueOf(),

  instName: '小麦开发部',
  selectedBGM: {
    id: 0,
    category: '默认',
    name: '无背景音乐',
    url: ''
  },
  instPhone: '',
  instAddress: '',
  wechatMiniOnlineStatus: '',
  xmPayRegisterStatusEnum:'',
  isLimited: true,
  limitNum: 10,
  canPay: false,
  hasOpenSMSVerify: false,
  hasInstOpenSMSVerify: false,
  smsRemainNumber: 0,
  hasMaterialSaved: true,
  mustMinPay: false,
  payType: '定金', // 1定金 2全额
  payNumber: 100,
  virtualGroup: false,
  activityRule: '',
  activityIntros: [
    {
      type: 'text',
      value:
        '1.活动时间内，学生家长参加活动并达到成团人数要求，即可享受相应课程优惠。\n\n' +
        '2.团长：开团成功后将拼团信息分享给好友，邀请好友一起拼团。拼团时间内，参团人数达到设置最低人数，则拼团成功；否则视为拼团失败；\n\n' +
        '3.团员：通过好友链接或机构分享参团成功的成员，可邀请好友一起拼团，拼团时间内，参团人数达到设置最低人数，则拼团成功；否则视为拼团失败。\n\n' +
        '4.一个用户仅可开团/参团一次。\n\n' +
        '5.若检测出参与用户存在人为因素刷单，恶意开团/参团等行为，机构有权解除其参与资格。\n\n' +
        '6.本活动最终解释权归机构所有'
    }
  ],
  activityTitle: '活动说明',
  activitySwitch: true,
  contactTitle: '联系方式',
  contactInfo: '①领奖时间：团圆值达到50点后即可领奖\n\n' + '②领奖地址：**机构本地校区\n\n' + '③领奖电话：0571-87007093\n\n',
  contactSwitch: true,
  institutionTitle: '机构介绍',
  institutionSwitch: true,
  institutionIntros: [
    {
      type: 'text',
      value: '**机构是浙江省实力卓越的民营艺术类教育培训机构，专注于4-12岁孩子的美术培训。在杭州，宁波，嘉兴都设有分校区。'
    }
  ],
  tag: '',
  viewBackground: 'https://image.xiaomaiketang.com/xm/57MzFkZGTa.png',
  bgmIcon: 'https://image.xiaomaiketang.com/xm/Qb4SZSjbb6.png',
  contactIcon: 'https://image.xiaomaiketang.com/xm/Qb4SZSjbb6.png',
  scanBackground: 'https://image.xiaomaiketang.com/xm/6RjMeEGc6a.png',
  scanTextColor: '#FEF139',
  scanSubTextColor: '#FFF',
  releaseStatus:'',
  scanNumber: '',
  joinNumber: '',
  supportPay: false,
  channel: '',
  iWantDoIcon: 'https://image.xiaomaiketang.com/xm/Qb4SZSjbb6.png',
  inviteIcon: 'https://image.xiaomaiketang.com/xm/Qb4SZSjbb6.png',
  limitFlag: false,
  limitFlagNumber: 0,
  ladderGroupList: [
    {
      groupSize: 2,
      groupPrice: 100
    }
  ],
  solitareingList: [],
  headReward: '',
  bargainParameter: {
    prizeNum: 0,
    prizeLeftCount: 0,
    minPrice: 888,
    maxPrice: 1800,
    minCutPrice: 20,
    maxCutPrice: 40,
    intervalTime: 2,
    currentRank: 0,
    currentPrice: 0,
    totalBargainTime: 0
  },
  tyTypeParameter: {
    intervalTime: 2, // 砍价时间间隔 单位分钟
    prizeNum: 0, // 奖品数量
    prizeLeftCount: 0, // 奖品剩余数量
    unitNum: 50, // 单位兑奖数量
    goodValue: 16, // 好东西数量
    normalValue: 8, // 普通东西数量
    badValue: 4, // 坏东西数量
    vebStr: '', // 活动单位动词
    unitTitle: '', // 活动单位标题
    unitStr: '' // 活动单位字符串
  },
  gachaTypeParameter: {
    showPlayDesc: false,
    hasSubtractPrizeLength: false, // 发布后修改了奖品数量
    playType: 'scholarship', // 玩法说明
    grachaShow: true,
    gachaType: 'scholarship', // 选择活动类型
    scholarship: {
      least: 1, //每次最少 （新增）
      most: 5, //每次最多 （新增）
      highest: 100, //每个学员最高 （新增）
      coverTiny: 'https://image.xiaomaiketang.com/xm/xmxImage1589610904129', //预览小图200*200
      coverMiddle: 'https://image.xiaomaiketang.com/xm/xmxImage1589610958983', //预览中图500*500
      coverLarge: 'https://image.xiaomaiketang.com/xm/xmxImage1589611003101', //预览大图750*360
      posterImage: 'https://image.xiaomaiketang.com/xm/PXG6nh6wx5.png', // 海报主图
      await: 'https://image.xiaomaiketang.com/xm/EYSQDEPifF.gif', //奖学金等待图 （新增）
      start: 'https://image.xiaomaiketang.com/xm/MMpTMs5i6p.gif' //奖学金开始图 （新增）
    },
    prize: {
      addNum: 1,
      proList: [
        //奖品设置 （新增）
        {
          img: 'https://image.xiaomaiketang.com/xm/zJ5p6K2Jjn.png',
          name: 'LEGO乐高积木霍格沃茨城堡',
          num: '20',
          winningProbability: 10,
          description:
            '霍格沃茨城堡是乐高系列与哈利波特的重要联名哦~城堡整体造型的简化程度得当，非常适合锻炼小朋友的首脑协调能力，助力提升孩子的专注力。充分发挥每个孩子的想象力、创造力、快让孩子用稚嫩的小手搭建充满创意的大世界吧'
        }
      ],

      cardTextColor: '#FFFFFF', //卡片文本颜色 （新增）
      cardRadius: 5, //卡片圆角 （新增）
      smallBorderWidth: 2, //卡片边框宽度（小） （新增）
      smallBorderColor: '#B865E5', //卡片边框颜色（大） （新增）
      bigBorderWidth: 6, //卡片边框宽度（小）（新增）
      bigBorderColor: '#B865E5', //卡片边框颜色（大） （新增）
      coverTiny: 'https://image.xiaomaiketang.com/xm/aCxSQhXnAp.png', //预览小图200*200
      coverMiddle: 'https://image.xiaomaiketang.com/xm/CGtxG8ZhaS.png', //预览中图500*500
      coverLarge: 'https://image.xiaomaiketang.com/xm/eBc8pMi4zH.png', //预览大图730*360
      posterImage: 'https://image.xiaomaiketang.com/xm/bPe6GrBBS3.png', // 海报主图
      await: 'https://image.xiaomaiketang.com/xm/ZMNY5Q6Ndt.gif', //奖品等待图 （新增）
      start: 'https://image.xiaomaiketang.com/xm/WHjw6CNYaD.gif' //奖品开始图（新增）
    },
    buttonSet: {
      //按钮设置 （新增）
      gachaGetScholarship: 'https://image.xiaomaiketang.com/xm/Z7WD8d7EWA.png',
      findFriendHelp: 'https://image.xiaomaiketang.com/xm/6CJRrsekdX.png',
      helpHeGetScholarship: 'https://image.xiaomaiketang.com/xm/timNKiwhia.png',
      backHome: 'https://image.xiaomaiketang.com/xm/twQj5hkP8G.png',
      meJoin: 'https://image.xiaomaiketang.com/xm/6zQ6RAfGSC.png',
      startGacha: 'https://image.xiaomaiketang.com/xm/R2QEjRJpxF.png',
      helpHeGacha: 'https://image.xiaomaiketang.com/xm/HiPx3cfrD2.png',
      buttonBg: 'https://image.xiaomaiketang.com/xm/AGXb7W6iYT.png', //按钮背景色 （新增）
      shareGuideImg: '' //分享引导图设置 （新增）
    },
    modalSection: {
      lotterySuccess: 'https://image.xiaomaiketang.com/xm/phH5X5Z8wc.png',
      lotteryfail: 'https://image.xiaomaiketang.com/xm/6nRPD63prf.png',
      textColor: '#B865E5'
    },
    dayTimes: 5,
    totalTimes: 5,
    dayTimesChecked: true,
    totalTimesChecked: false,
    mainTextColor: ''
  },
  distributeTypeParameter: {
    hasSubtractLimitBuyerNum: false,
    distributeMode: 'ANY_TIME', // 分销模式 'ANY_TIME':无需购买，'AFTER_BUY':购课之后
    openDistributeModeModal: false,
    openDistributeRewardModal: false,
    firstReward: '', // 一级分销获取佣金
    secondReward: '', // 二级分销获取佣金
    hasOpenSecondDistribute: false, // 是否开启二级分销
    hasCheckUserAgreement: false, // 是否勾选用户协议
    isUserAgreementVisible: false,
    courseDesc: [
      {
        type: 'text',
        value:
          '英语优+课程有十一大教学模块，涵盖中国、美国小学英语教学大纲的知识点内容，提升学生的听说读写能力，轻松应对中高考改革！\n\n每一句纯正地道的优+英语都将帮助学员发音标准，跨越从前口语和听力这两道无法逾越的障碍，从而提高自信，敢于开口。说得准、听得懂，将大大提高学习效率和学习兴趣，不再死记硬背，让学习回归本色！\n\n'
      }
    ]
  },
  chooseDegree: {
    name: '低',
    index: 0
  },
  rankList: [],
  urlUid: '',
  chance: 60,
  count: 20,
  groupSwitch: false,
  unGroupSwitch: true,
  autoCancel: false,
  groupImageList: ['', '', ''],
  groupList: [],
  groupCreateNumber: 0,
  groupCompleteNumber: 0,
  groupFullNumber: 0,
  groupFull: false,
  showFooter: true,
  hasPay: 0,
  cancel: false,
  hasSignIn:false,
  hasPaidNumber: 0,
  showJoinFooter: false,
  joinGroupFlag: false,
  posterIcon: '', // 海报图标,
  contactQrcode: '', // 二维码图片
  signupItemConfig: '{"age":false,"grade": false,"school": false,"birthday": false,"gender": false, "intention": false, "customizeList": []}',
  userAwardInfo: {},
  showBarrage: false,
  showNum: true,
  showData: true,
  xmMajordomo: false,
  xcxType: getUrlParam('xcxType') || 'xmx',
  posterUrl: '',
  posterName: '', // 海报中的姓名
  posterAvatar: '', // 海报中的头像
  version: '1', // 默认新版本
  showWantDo: false,
  posterImage: '', // 海报中的图片
  leftQuota: 0,
  showPayEditModal: false,
  showInValidModal: false,
  needLimitNormalStu: false, // 是否开启只允许潜在学员报名参与活动的开关
  selectedCardIndex: 0,
  gachaLoading: false,
  gachaStart: false,
  studentInfo: {
    //学员信息设置  （新增）
    bottomColor: 'rgba(184, 101, 229, 0.5)', //区域底色 （新增）
    specialTextColor: '#FF4F4F' //特显文本颜色 （新增）
  },
  detailLoaded: false, // 活动页面detail接口是否调用完成
  showWesiteBtn: false,
  avatar: '', //分销类型的活动用户的头像
  nickname: '', //分销类型用户的昵称
  distributeOrderCreateTime: new Date().valueOf(), // 分销类型的活动未支付订单剩余时间
  myReward: 0, // 我参与分销分享总共获取的奖励金
  distributePurchaseList: [],
  distributeTradeId: '', //分销的订单ID
  distributeTabFixed: false,
  loadedConfig: false,
  showExtId:'1'
};
export default state;
